import { mc, StyleProps } from '@styles';
import { TestIdProps } from '@utils';
import React, { FC, ReactNode } from 'react';

interface Props extends StyleProps, TestIdProps {
  children?: ReactNode;
}

export const PostSidebarSectionContainer: FC<Props> = ({ testId, className, children }) => (
  <div data-testid={testId} className={mc('py-8 border border-neutral-gray rounded-lg', className)}>
    {children}
  </div>
);

export type PostSidebarSectionContainerProps = Props;
export default PostSidebarSectionContainer;
